import { useCallback } from "react";
import { useAuthStore } from "../store/authStore.js";

/**
 * Returns a memoized `can(permission)` function that checks the current
 * user's resolved permission list.
 *
 * Usage:
 *   const can = usePermission();
 *   if (can("monitors.create")) { ... }
 */
export function usePermission() {
  const permissions = useAuthStore((s) => s.permissions);
  return useCallback(
    (permission) => Array.isArray(permissions) && permissions.includes(permission),
    [permissions]
  );
}
